import { localisedValue } from "utils"

const languageTransformer = response => {
    return response?.map(e => {
      return {
        ...e,
        id: e?.id,
        label: localisedValue({ object: e, key: "title" }),
        value: e?.id?.toString(),
      }
    })
  }

export default languageTransformer